import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModules } from "../../redux/services/moduleSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const Lectures = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modules = useSelector((state) => state.module.moduleData?.module_data || []);

  useEffect(() => {
    dispatch(getModules({}));
  }, [dispatch]);

  return (
    <div className="sm:p-6">
      <h1 className="text-2xl font-semibold mb-6">Modules</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6">
        {modules.map((module) => (
          <div
            key={module._id}
            onClick={() =>
              navigate(`${ROUTES.COURSES.LECTURES_MODULE}?moduleId=${module._id}`, {
                state: { module },
              })
            }
            className="bg-card  shadow-theme rounded-2xl overflow-hidden cursor-pointer hover:shadow-theme transition-all"
          >
            <img src={module.image} alt={module.name} className="w-full h-28 object-cover" />
            <div className="p-4">
              <h3 className="text-lg font-semibold text-foreground ">{module.name}</h3>
              <p className="text-sm text-foreground line-clamp-2">{module.subTitle}</p>
              <div className="flex justify-between text-sm mt-2  ">
                <p>Lectures: {module.totalLecture}</p>
                <p>Tests: {module.totalTest}</p>
              </div>
              <a href={module.link} target="_blank" rel="noreferrer" className="text-primary underline text-sm mt-2 inline-block">
                Visit Link
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Lectures;
